import React from "react";

import { Grid, Typography } from "@mui/material";
import CountUp from "react-countup";

import { Box1400 } from "./styles";

const Archivements = () => {
  const items = [
    { num: 84, text: "projects worked" },
    { num: 52, text: "clients worked with" },
    { num: 29, text: "awards won" },
  ];
  return (
    <Box1400 sx={{ margin: "80px auto" }}>
      <Grid container spacing={3}>
        {items.map((item) => {
          return (
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={4}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              key={`archivement-${item.text}`}
            >
              <Typography
                sx={{ fontSize: 100, fontWeight: 600 }}
                color="primary"
                className="text-glow-primary"
              >
                <CountUp end={item.num} enableScrollSpy />
              </Typography>
              <Typography color="common.white" sx={{ fontSize: 42 }}>
                {item.text}
              </Typography>
            </Grid>
          );
        })}
      </Grid>
    </Box1400>
  );
};

export default Archivements;
